export default __webpack_public_path__ + "static/case-study-icon.webp";